module.exports = function getResource (label, vars = []) {
    let resources = {
        checkoutButton: 'Passer à la caisse',
        continueToCheckoutButton: 'Passer à la caisse'

    };
    return resources[label];
};
